import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationCheckService } from 'src/app/services/auth/authentication-check.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Location } from '@angular/common';


@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm;
  errorMessage: Boolean = true;
  message = "";
  mobileNo = '';
  mobilenoError = false;
  otpError = false;
  otp = '';
  userID = '';

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private formBuilder: FormBuilder,
    private auth: AuthenticationCheckService,
    private toast: ToastClientService,
    public location: Location
  ) {
    this.checkLogin();
    this.loginForm = formBuilder.group({
      username: ['', Validators.compose([
        Validators.required
      ])],
      password: ['', Validators.compose([
        Validators.required,
        Validators.minLength(6)
      ])],
    });


    // this.loginForm = formBuilder.group({
    //   email: ['', Validators.compose([
    //     Validators.required,
    //     Validators.email
    //   ])],
    //   password: ['', Validators.compose([
    //     Validators.required,
    //     Validators.minLength(6)
    //   ])],
    // });


    this.loginForm.valueChanges
      .subscribe(data => {

      });
  }

  ngOnInit() {
    // this.testApi();
  }

  checkLogin() {
    let previousURL = localStorage.getItem("previousURL")
    let login = localStorage.getItem("login")
    if (login == 'true') {
      this.router.navigateByUrl(previousURL)
    }
  }


  // login(formData) {

  //   if (this.loginForm.invalid) {
  //     this.errorMessage = false;

  //     if (formData.email == "" && formData.password == "") {
  //       this.message = "Please enter the email and password"
  //     }
  //     else if (formData.email == "") {
  //       this.message = "Please enter the email"
  //     }
  //     else if (!this.loginForm.controls.email.valid) {
  //       this.message = "Please enter a valid email address"
  //     }
  //     else if (formData.password == "") {
  //       this.message = "Please enter the password"
  //     }

  //   } else {
  //     this.message = "";

  //     let apiUrl = this.apiConfig.login;

  //     let body = JSON.stringify({
  //       "LoginForm": {
  //         "email": formData.email,
  //         "password": formData.password,
  //         "program_id": 1
  //       }
  //     });

  //     this.apiService.post(apiUrl, body)
  //       .subscribe((res: any) => {
  //         if (res.status == 200) {

  //           this.errorMessage = true;
  //           let body = res.body;

  //           this.toast.Success('Login successful');

  //           localStorage.setItem("user_name", (res.body.data.user_name));
  //           localStorage.setItem("user_id", (res.body.data.user_role));
  //           localStorage.setItem("branch_id", res.body.data.branch_id)

  //           this.auth.saveAuth(body.data.access_token);

  //           if (body.data.user_role == 1) {
  //             this.router.navigate(["hubadmin"]);
  //           }
  //           else {
  //             this.toast.Success('You dont have access to this module');
  //           }
  //         }
  //       }, err => {
  //         this.errorMessage = false;
  //       })
  //   }
  // }



  login(formData) {

    if (this.loginForm.invalid) {
      console.log()
      this.errorMessage = false;
      if (formData.username == "" && formData.password == "") {
        this.message = "Please enter the username and password"
      } else if (formData.username == "") {
        this.message = "Please enter the username"

      } else if (formData.password == "") {
        this.message = "Please enter the password"
      }
    } else {
      let apiUrl = this.apiConfig.login;
      let body = JSON.stringify({ "LoginForm": { "username": formData.username, "password": formData.password, "program_id": 1 } });
      this.apiService.post(apiUrl, body)
        .subscribe((res: any) => {
          if (res.status == 200) {
            this.errorMessage = true;
            let body = res.body;
            this.toast.Success('Login successful');
            localStorage.setItem("user_name", (res.body.data.user_name));
            localStorage.setItem("user_id", (res.body.data.user_role));
            localStorage.setItem("branch_id", res.body.data.branch_id)
            this.auth.saveAuth(body.data.access_token);
            if (body.data.user_role == 1) {
              this.router.navigate(["hubadmin"]);
              //this.router.navigate(["agent"])
            }
            else {
              this.toast.Success('You dont have access to this module');
            }
          }
        }, err => {
          this.errorMessage = false;
          // this.router.navigate(["hubadmin"]);

        })
    }

  }


  isValid(field): boolean {
    let isValid: boolean = false;
    if (this.loginForm.controls[field].touched == false) {
      isValid = true;
    } else if (this.loginForm.controls[field].touched == true && this.loginForm.controls[field].valid == true) {
      isValid = true;
    }
    return isValid;
  }


}


